import * as React from 'react'
import Box from '@mui/material/Box'
import { WWMXGrid } from '@user/components/xGrid'
import { useActions } from './useActions'
import { useGetColumnData } from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateDialog/PestPacLocations/useGetColumnData'
import { useData } from './useData'
import useMediaQuery from '@mui/material/useMediaQuery'
import {
  pestPacLocationsDuplicatesDefaultColumns,
  pestPacLocationsDuplicatesDefaultColVis,
} from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateDialog/PestPacLocations/tableColumn'
import { ILocationSearchModel } from '@user/query/useDuplicateLocationSearch'

export interface PestPacLocationsDuplicatesProps {
  highlights?: Record<string, string>
  createOppCallback: (location: ILocationSearchModel) => void
  handleDuplicateManageClick?: () => void
  loading?: boolean
}

export const PestPacLocationDuplicates = ({
  highlights,
  createOppCallback,
  handleDuplicateManageClick,
  loading,
}: PestPacLocationsDuplicatesProps) => {
  const {
    duplicatesCount,
    orderBy,
    page,
    perPage,
    densityMode,
    onStateChange,
    tableRows,
    searchResultCount,
    searchText,
  } = useData()

  const {
    loading: colsLoading,
    columns,
    columnVisibility,
    apiRef,
  } = useGetColumnData({
    densityMode: densityMode,
    highlights,
    createOppCallback,
    handleDuplicateManageClick,
  })

  const {
    onColumnWidthChange,
    onSaveColumnState,
    onSortModelChange,
    sortModel,
    handlePaginationModelChange,
  } = useActions({ columns, orderBy })

  const isMobile = useMediaQuery('(max-width:900px)')

  return (
    <Box minHeight={'calc(100svh - 226px)'} bgcolor={'#F9FAFB'}>
      <WWMXGrid
        applyCustomStyles={true}
        apiRef={apiRef}
        virtualScrollerHeight={
          densityMode === 'compact'
            ? 316
            : densityMode === 'standard'
              ? 333
              : 350
        }
        // columns
        columnVisibilityModel={columnVisibility}
        columns={colsLoading ? [] : columns}
        onColumnWidthChange={(e) =>
          onColumnWidthChange(e?.colDef, columns, columnVisibility)
        }
        columnsSelectorProps={{
          saveCallback: (e) => onSaveColumnState(e, columns),
          defaultColumns: pestPacLocationsDuplicatesDefaultColumns,
          defaultVisibility: pestPacLocationsDuplicatesDefaultColVis,
          lockedColumns: ['actions'],
        }}
        pinnedColumns={{ left: !isMobile ? ['actions'] : [] }}
        //state
        isDensityEnable
        density={densityMode}
        onStateChange={onStateChange}
        // rows
        loading={loading || colsLoading}
        rows={colsLoading ? [] : tableRows}
        rowCount={searchText !== '' ? searchResultCount : duplicatesCount}
        // pagination
        paginationModel={{ page: page - 1, pageSize: perPage }}
        onPaginationModelChange={handlePaginationModelChange}
        pageSizeOptions={[10, 25, 50]}
        // sorting
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        width="100%"
        hideDefaultBtn={true}
      />
    </Box>
  )
}

PestPacLocationDuplicates.displayName = 'PestPacLocationDuplicates'
